import React from 'react'
import { Grid } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import { Oops as logo } from '@edge/spark/ui-assets'

interface Props {
    message: string
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            flexGrow: 1,
            padding: 20,
        },
        error: {
            textAlign: 'center',
        },
        content: {
            flexGrow: 1,
        },
        container: {
            minHeight: '80vh',
        },
        oopsImg: {
            paddingTop: '10px',
            textAlign: 'center',
        },
    }),
)

const ErrorLoadingReport = ({ message }: Props): React.ReactElement => {
    const styles = useStyles()

    return (
        <div className={styles.root}>
            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={3}>
                <Grid container direction="column" alignItems="center" justifyContent="center">
                    <Grid item xs={12}>
                        <img className={styles.oopsImg} src={logo} alt="Error" />
                    </Grid>
                    <Grid item xs={12}>
                        <h2 className={styles.error}>Error Loading Report</h2>
                    </Grid>
                    <Grid item xs={12}>
                        <h5>({message})</h5>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default ErrorLoadingReport
